<template lang="pug">
  .PrecisionMarketing
    top-informations(title="精准营销" subtitle="数智驱动营销模式创新，深度挖掘企业价值" text="Innovative marketing model enhances corporate value")
    project-design(text="为企业提供一站式、多渠道、全链路、智能化的精准营销闭环，助力企业实现用户增长。基于精准客户洞察，赋予品牌与全渠道目标用户精准及时互动沟通的能力。强大自动化营销引擎和独创客户旅程编辑器，让品牌的营销策略落地到系统执行层面成为可能。")
    .background
      framework(:framework="framework" background-class="marketBackground")
      core-tech(:core-tech="coreTech")
    scene(:scenes="['数字教育', '数字旅游', '数字医疗']")
</template>

<script>
  import TopInformations from "@/views/Solution/components/TopInformations/TopInformations";
  import ProjectDesign from "@/views/Solution/components/ProjectDesign/ProjectDesign";
  import Framework from "@/views/Solution/components/Framework/Framework";
  import Scene from "@/views/Solution/components/Scene/Scene";
  import CoreTech from "@/views/Solution/components/coreTech/coreTech";
  // import framework from '@/assets/images/56614544.png'
  const framework = 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E6%9E%B6%E6%9E%84%E5%9B%BE/%E8%A7%A3%E6%94%BE%E6%96%B9%E6%A1%88-%E7%B2%BE%E5%87%86%E8%90%A5%E9%94%80-%E6%9E%B6%E6%9E%84%E5%9B%BE.png';
  import human from "@/assets/images/16.png"
  import comprehend from '@/assets/images/眼睛.png'
  import todoList from '@/assets/images/todo_list_96px.png'
  import physics from '@/assets/images/physics_128px.png'
  export default {
    name: "PrecisionMarketing",
    components: {CoreTech, Scene, Framework, ProjectDesign, TopInformations},
    props: {},
    data() {
      return {
        framework,
        coreTech: [
          {img: comprehend, title: '用户理解', text: '强大的用户理解标签体系，多维度绘制目标人群全貌特征，深入透视关联因素'},
          {img: human, title: '人群定向', text: '提供海量高价值用户资源，根据人口属性和兴趣倾向特征，灵活地筛选人群，自由组合，lookalike一键智能扩散'},
          {img: todoList, title: '内容策划', text: '根据品牌洞悉与受众分析，智能推荐广告创意与落地页方案'},
          {img: physics, title: '效果优化', text: '打通各渠道营销效果数据，实时数据回流与分析，提供营销全链路的优化方案'},
        ],
      };
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .PrecisionMarketing {
    .background {
      VStack(center, center)
      background url("../../../assets/images/实现架构底板.png") no-repeat center top
      background-size 100%
    }
  }
  /deep/.coreTech {
    > div p {
      width 420px
    }
  }
  @media (max-width screenWidth) {
    /deep/.coreTech {
      > div p {
        width auto
      }
    }
    .PrecisionMarketing {
      .background {
        background none
        margin-top -50px
      .Framework {
        padding-bottom 0
      }
      }
    }
  }
</style>
